import { useCallback, useState } from 'react';
import { UserApi } from '../../../api';
import { PublicUserDisplayProfileEnrichment } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';

const useHttpGetDisplayProfilesByUserSubsIncludingDetached = () => {
    const userApi: UserApi = useContainer(UserApi);
    const [profilesBySub, setProfilesBySub] = useState<Record<string, PublicUserDisplayProfileEnrichment>>({});

    const exec = useCallback(
        (userSubs: string[]) => {
            const uniqueUserSubs = Array.from(new Set(userSubs.filter(Boolean)));

            if (uniqueUserSubs.length === 0) {
                setProfilesBySub({});
                return;
            }

            const { exec: requestExec, abort } = userApi.getDisplayProfilesByUserSubsIncludingDetached({
                body: { userSubs: uniqueUserSubs },
                onSuccess: res => {
                    const bySub = (res.body ?? []).reduce<Record<string, PublicUserDisplayProfileEnrichment>>((acc, profile) => {
                        if (profile.userSub) {
                            acc[profile.userSub] = profile;
                        }
                        return acc;
                    }, {});
                    setProfilesBySub(bySub);
                },
                onError: () => {
                    setProfilesBySub({});
                },
            });

            requestExec();
            return abort;
        },
        [userApi]
    );

    return { profilesBySub, exec };
};

export default useHttpGetDisplayProfilesByUserSubsIncludingDetached;
